import React, { useState } from "react";
import { Popover } from "@blueprintjs/core";
import classNames from "classnames";
import * as styles from "./styles.module.scss";
const SourceName = ({ className, tooltip, children }) => {
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
    return (React.createElement(Popover, { content: tooltip, isOpen: tooltipIsOpen, minimal: true, disabled: !tooltip, openOnTargetFocus: false, placement: "top", popoverClassName: styles.tooltip, targetTagName: "div", className: classNames(styles.root, className, { [styles["with-tooltip"]]: !!tooltip }), modifiers: {
            preventOverflow: {
                enabled: true,
                fn: (data) => {
                    const popperInstance = data?.instance?.state?.attributes?.popper;
                    const popperInstanceIsHidden = popperInstance && popperInstance["data-popper-reference-hidden"];
                    if (popperInstanceIsHidden) {
                        setTooltipIsOpen(false);
                    }
                },
            },
        } },
        React.createElement("div", { onClick: () => setTooltipIsOpen(true), onMouseLeave: () => setTooltipIsOpen(false) }, children)));
};
export default SourceName;
